import { useEffect, useLayoutEffect, useState } from 'react';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { useLocation } from 'react-router';
import { useSegmentationQueryContext } from '../contexts/segmentationQuery';

/**
 * Hook that retrieves a query from location state.
 */

export const useLocationSearchQuery = () => {
  const location =
    useLocation<Partial<{ searchQuery: CompleteQuery; automaticallyLoadResults: boolean }>>();
  const [locationStateQuery, setLocationStateQuery] = useState(location.state?.searchQuery);
  const { refreshQueryResults } = useSegmentationQueryContext();

  // scrolls page to the top
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // update locationState query when location state query is available
  useEffect(() => {
    if (location.state?.searchQuery) setLocationStateQuery(location.state.searchQuery);
  }, [location]);

  // if locationStateQuery is populated show query results
  useEffect(() => {
    if (locationStateQuery && location.state?.automaticallyLoadResults)
      refreshQueryResults({ searchQuery: locationStateQuery });
  }, [locationStateQuery]);

  return locationStateQuery;
};
